import { put, call, takeLatest } from "redux-saga/effects";

import {
  SellerLoginRequest,
  SellerLoginSuccess,
  SellerloginFailure,
} from "./Login-slice";
import axios from "axios";
import { API_URL } from "../../utils/Api";

function* SellerLoginSaga(action) {
  try {
    const response = yield axios.get(`${API_URL.api}/login`, {
      params: action.payload,
    });
    yield put(SellerLoginSuccess(response.data));
  } catch (error) {
    yield put(SellerloginFailure(error.message));
  }
}

export function* watchSellerlogin() {
  yield takeLatest(SellerLoginRequest.type, SellerLoginSaga);
}
